import React from 'react'

const Menu = () => {
    return (
        <iframe src="https://order.ranna.co.uk/e2417bce-8a16-40c6-d9be-81deb5c8fced"
            frameborder="0"
            style={{ width: "100%", height: "90vh", border: "none" }}
            title="Oldkent-Shisha-menu"
        />
    )
}

export default Menu